import { Typography } from "@material-ui/core";
import { makeStyles } from "@material-ui/core/styles";
import React from "react";
import { Route, Switch, useRouteMatch } from "react-router-dom";
import Completedtab from "../img/Completedtab.png";
import customAS from "../img/customAS.png";
import genericAS from "../img/genericAS.png";
import gtip1 from "../img/gtip1.png";
import gtip2 from "../img/gtip2.png";
import Selectclass from "../img/Selectclass.png";
import Starting1 from "../img/Starting1.png";
import Starting2 from "../img/Starting2.png";
import Studentsanswer from "../img/Studentsanswer.png";
import tip1 from "../img/tip1.png";
import tip2 from "../img/tip2.png";
import tip3 from "../img/tip3.png";
import tip4 from "../img/tip4.png";
import Viewresults from "../img/Viewresults.png";

const useStyles = makeStyles((theme) => ({
  topicMain: {},
  root: {
    minHeight: "50vh",
    marginTop: "70px",
    paddingBottom: "50px",
    width: "100%",
    maxWidth: "800px",
    "& a": {
      color: "#4381b5",
    },
    "& h2": {
      marginBottom: "30px",
    },
    "& h4": {
      margin: "30px 0px",
    },
    "& img": {
      boxShadow: "0 3px 10px rgb(0 0 0 / 0.4)",
      borderRadius: "4px",
      // transition: "transform .2s",
      // "&:hover": {
      //   transform: "scale(1.3)",
      // },
    },
  },
  detailsgrid: {
    height: "40px",
  },
  detailsgridline: {
    display: "inline-block",
    margin: "auto 30px",
  },
  imgSize: {
    maxWidth: "350px",
    width: "90%",
    display: "block",
    margin: "20px auto",
    marginBottom: "40px",
  },
  imgSize2: {
    maxWidth: "370px",
    width: "90%",
    margin: "20px auto",
    display: "block",
    marginTop: "20px",
  },
  imgSize3: {
    maxWidth: "300px",
    width: "80%",
    margin: "15px 20px 20px 20px",
    display: "block",
  },
  hyperlink: {
    textDecoration: "none",
    color: "#8277FF !important",
  },
  fontHeading: {
    marginBottom: "40px",
    fontSize: "28px",
    [theme.breakpoints.down("xs")]: {
      fontSize: "22px",
    },
  },
  highlighted: {
    backgroundColor: "#d8d2e7",
    width: "max-content",
    borderLeft: "5px solid #d8d2e7",
    borderRight: "5px solid #d8d2e7",
  },
}));

function HowCanITakeOnline() {
  const classes = useStyles();
  return (
    <div className={classes.root} style={{ maxWidth: "900px" }}>
      <div className={classes.accordionSummary}>
        <Typography variant="h5" className={classes.fontHeading}>
          How can I take an online assessment?
        </Typography>
      </div>
      <div display="block">
        <Typography className={classes.details} variant="body2">
          If your teacher has released an online assessment, it will be
          available in your student portal.
          <br />
          <br />
          You can access it by following these steps:
          <br />
          <br />
          Log in and select your teacher’s class:
        </Typography>
        <img
          style={{ maxWidth: "800px" }}
          className={classes.imgSize}
          src={Selectclass}
          alt="Select class"
        />
        <Typography className={classes.details} variant="body2">
          You will see a list of the assessments that are currently released.
          Click the rocket icon on the assessment of interest.
        </Typography>

        <img
          style={{ maxWidth: "800px" }}
          className={classes.imgSize}
          src={Starting1}
          alt="Starting"
        />
        <Typography className={classes.details} variant="body2">
          Input the assessment password and click Start again.
        </Typography>

        <img
          style={{ maxWidth: "800px" }}
          className={classes.imgSize}
          src={Starting2}
          alt="Starting"
        />
        <Typography className={classes.details} variant="body2">
          The assessment will now start. Input your answers and when done, click
          submit:
        </Typography>
        <img
          style={{ maxWidth: "800px" }}
          className={classes.imgSize}
          src={Studentsanswer}
          alt="Answer"
        />
        <Typography className={classes.details} variant="body2">
          You are now done. If your teacher allows it, you can immediately see
          your results:
        </Typography>
        <img
          style={{ maxWidth: "800px" }}
          className={classes.imgSize}
          src={Viewresults}
          alt="View results"
        />
        <Typography className={classes.details} variant="body2">
          You can also see all your online assessment results in the completed
          tab.
        </Typography>
        <img
          style={{ maxWidth: "800px" }}
          className={classes.imgSize}
          src={Completedtab}
          alt="Completed"
        />
      </div>
    </div>
  );
}
function HowCanITakePaper() {
  const classes = useStyles();
  return (
    <div className={classes.root} style={{ maxWidth: "900px" }}>
      <div className={classes.accordionSummary}>
        <Typography variant="h5" className={classes.fontHeading}>
          How can I take a paper assessment?
        </Typography>
      </div>
      <div display="block">
        <Typography className={classes.details} variant="body2">
          <a href="#howpaper">How can I take paper assessments?</a>
          <br />
          <br />
          <a href="#instructionspaper">
            Instructions for inputting answers into written assessments
          </a>
          <br />
          <br />
          <a href="#instructionsmultiple">
            Instructions for inputting answers into multiple choice assessments
          </a>
          <br />
          <br />
          <a href="#receivingresults">
            Receiving results for paper assessments
          </a>
          <br />
          <br />
        </Typography>
        <Typography className={classes.highlighted} variant="h6" id="howpaper">
          How to take paper assessments?
        </Typography>
        <Typography className={classes.details} variant="body2">
          Your teacher will give you a paper answer sheet like this one:
        </Typography>
        <img
          style={{ maxWidth: "400px" }}
          className={classes.imgSize3}
          src={customAS}
          alt="Custom Answer Sheet"
        />
        <Typography className={classes.details} variant="body2">
          Or, if multiple choice it may look like this:
        </Typography>

        <img
          style={{ maxWidth: "400px" }}
          className={classes.imgSize3}
          src={genericAS}
          alt="Generic Answer Sheet"
        />
        <Typography className={classes.details} variant="body2">
          Once you have the paper, fill in your final answers and once done hand
          the paper back to your teacher.
        </Typography>

        <Typography
          className={classes.highlighted}
          variant="h6"
          id="instructionspaper"
        >
          Instructions for inputting answers into assessments:
        </Typography>
        <Typography className={classes.details} variant="body2">
          When inputting written answers, make sure to:
          <br />
          <br />
        </Typography>
        <ul>
          <li>
            <Typography
              display="block"
              className={classes.imgExplainerText}
              variant="body2"
            >
              Write with large and neat characters:
            </Typography>
          </li>
          <img className={classes.imgSize3} src={tip3} alt="Custom Tip 1" />
          <br />
          <li>
            <Typography
              display="block"
              className={classes.imgExplainerText}
              variant="body2"
            >
              Print characters(do not write cursive):
            </Typography>
          </li>
          <img className={classes.imgSize3} src={tip1} alt="Custom Tip 2" />
          <br />
          <li>
            <Typography
              display="block"
              className={classes.imgExplainerText}
              variant="body2"
            >
              Write inside the box:
            </Typography>
          </li>
          <img className={classes.imgSize3} src={tip2} alt="Custom Tip 3" />
          <br />
          <li>
            <Typography
              display="block"
              className={classes.imgExplainerText}
              variant="body2"
            >
              Completely erase mistakes:
            </Typography>
          </li>
          <img className={classes.imgSize3} src={tip4} alt="Custom Tip 4" />
        </ul>

        <Typography
          className={classes.highlighted}
          variant="h6"
          id="instructionsmultiple"
        >
          Instructions for inputting answers into multiple-choice assessments:
        </Typography>
        <Typography className={classes.details} variant="body2">
          When inputting multiple choice answers, make sure to:
        </Typography>
        <br />
        <ul>
          <li>
            <Typography
              display="block"
              className={classes.imgExplainerText}
              variant="body2"
            >
              Fill circles fully
            </Typography>
          </li>
          <img className={classes.imgSize3} src={gtip1} alt="Custom Tip 1" />
          <br />
          <li>
            <Typography
              display="block"
              className={classes.imgExplainerText}
              variant="body2"
            >
              Use a dark color pen or pencil
            </Typography>
          </li>
          <img
            style={{ maxWidth: "220px" }}
            className={classes.imgSize3}
            src={gtip2}
            alt="Custom Tip 2"
          />
          <br />
        </ul>
        <Typography
          className={classes.highlighted}
          variant="h6"
          id="receivingresults"
        >
          Receiving results for paper assessments
        </Typography>
        <Typography className={classes.details} variant="body2">
          Once you hand in your assessment, if your teacher releases results,
          they will be emailed to you.
        </Typography>
      </div>
    </div>
  );
}

function TakingAssessmentsTopics() {
  const { path } = useRouteMatch();

  return (
    <>
      <Switch>
        <Route path={`${path}/how-can-i-take-online`}>
          <HowCanITakeOnline />
        </Route>
        <Route path={`${path}/how-can-i-take-paper`}>
          <HowCanITakePaper />
        </Route>
      </Switch>
    </>
  );
}

export default TakingAssessmentsTopics;
